import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2e30cf3b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.33_css-loader@6.11.0_webpack@5.82.1_@swc+core@1.7.26_may2kbd7dkqr6dwzd4fjrfzbbi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports